import { render, staticRenderFns } from "./PrizesTable.vue?vue&type=template&id=823d4790&scoped=true"
import script from "./PrizesTable.vue?vue&type=script&lang=js"
export * from "./PrizesTable.vue?vue&type=script&lang=js"
import style0 from "./PrizesTable.vue?vue&type=style&index=0&id=823d4790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823d4790",
  null
  
)

export default component.exports